export function initFilterShadow() {
  window.addEventListener("scroll", () => {
    const filters = document.getElementsByClassName("scroll-shadow");

    for (let filter of filters) {
      filter.classList.toggle("shadow-md", window.scrollY > 20);
    }
  });
}
